import { paymentStatus } from '../../constants/payment'

const PayForVerificationButton = ({ onClick, status }) => {
  if (status && status !== paymentStatus.REFUNDED) return

  return (
    <button
      onClick={onClick}
      className="w-full bg-amber-600 hover:bg-amber-700 text-white font-semibold py-2 px-4 rounded disabled:opacity-50"
    >
      Pay for Verification
    </button>
  )
}
export default PayForVerificationButton
